import {createFileRoute} from '@tanstack/react-router';

import DailyActivity from '@/practitioner/views/activity/DailyActivity';

export const Route = createFileRoute('/(practitioner)/practitioner/activity/$date')({
  component: DailyActivity,
  loader: ({params}) => ({
    date: params.date
  })
});
